// Generic function to handle snowplow tracking
function trackAudioEvent(action, label, location) {
  snowplow('trackStructEvent', {
    category: 'audio-playlist',
    action: action,
    label: label,
    ...(location && { property: location })
  });
}

// Exported functions for specific events
export function showAudioPlayer(label, location) {
  trackAudioEvent('impression', label, location); // open concept with an audio playlist event
}

export function playAudioPlayer(label, location) {
  trackAudioEvent('play', label, location); // click on ‘play’ event
}

export function pauseAudioPlayer(label, location) {
  trackAudioEvent('pause', label, location); // click on ‘pause’ event
}

export function endAudioPlayer(label, location) {
  trackAudioEvent('complete', label, location); // listened to 100% of the audio event
}

export function halfAudioPlayed(label, location) {
  trackAudioEvent('listened-50', label, location); // listen to 50% of the audio event
}
